/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { matchPath, useLocation } from 'react-router'
import { Link as RouterLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import {
    Avatar,
    Box,
    Divider,
    Drawer,
    FormControl,
    Hidden,
    Link,
    List,
    ListItem,
    ListItemIcon,
    ListSubheader,
    makeStyles,
    MenuItem,
    Select,
    Typography
} from '@material-ui/core'
import Logo from '../../../components/Logo'
import NavItem from './NavItem'
import axios from 'axios'
import authService from '../../../services/authService'
import { hasPermission } from '../../../utils/user'

const navConfig = [
    {
        subheader: 'Reports',
        items: [
            {
                title: 'Dashboard',
                icon: 'chart-pie-alt',
                href: '/app/dashboard'
            },
            {
                title: 'Analytics',
                icon: 'analytics',
                href: '/app/analytics'
            },
            /*{
                permissions: ['admin'],
                title: 'Live',
                icon: 'heartbeat',
                href: '/app/reports/live',
                hideOnSimpleDashboardView: true
            },*/
            {
                permissions: ['admin'],
                title: 'Funnel',
                icon: 'pencil-ruler',
                href: '/app/reports/funnel',
                hideOnSimpleDashboardView: true
            },
            {
                permissions: ['admin'],
                title: 'Business',
                icon: 'chart-line',
                href: '/app/reports/business',
                hideOnSimpleDashboardView: true
            }
            /*{
                    title: "Reports",
                    icon: "file-chart-line",
                    href: "/app/dashboard",
                    items: [
                        {
                            title: "Lifetime Value",
                            href: "/app/extra/charts/apex"
                        },
                        {
                            title: "Funnel",
                            href: "/app/reports/funnel"
                        }
                    ]
                }*/
        ]
    },
    /*{
            subheader: "Activity",
            items: [
                {
                    title: "Visitors",
                    href: "/app/social",
                    icon: "user-chart"
                },
                {
                    title: "Leads",
                    href: "/app/projects",
                    icon: "id-card"
                }
            ]
        },*/
    {
        subheader: 'Marketplace',
        items: [
            {
                title: 'Landing Pages',
                icon: 'pallet-alt',
                href: '/app/surveys'
            },
            {
                permissions: ['admin'],
                title: 'Prelanders',
                icon: 'arrow-alt-to-right',
                href: '/app/management/prelanders',
                hideOnSimpleDashboardView: true
            }
            /* {
                    title: "Campaigns",
                    icon: "poll-people",
                    href: "/app/management/products"
                },
                {
                    title: "Clients",
                    icon: "handshake",
                    href: "/app/management/customers"
                },
                {
                    title: "Marketing Messages",
                    icon: "mail-bulk",
                    href: "/app/management/customers"
                },
                {
                    title: "Tools",
                    icon: "hammer",
                    href: "/app/reports/dashboard-alternative",
                    items: [
                        {
                            title: "Banner Survey URL",
                            href: "/app/extra/charts/apex"
                        },
                        {
                            title: "Funnel",
                            href: "/app/extra/charts/apex"
                        }
                    ]
                },
                {
                    title: "Users",
                    icon: "users",
                    href: "/app/management/customers"
                },*/
        ]
    },
    {
        subheader: 'Financial',
        hideOnSimpleDashboardView: true,
        items: [
            {
                permissions: ['admin'],
                title: 'Invoices',
                icon: 'file-invoice',
                href: '/app/management/invoices'
            },
            {
                title: 'Credit Notes',
                icon: 'receipt',
                href: '/app/management/credit-notes'
            },
            {
                permissions: ['admin'],
                title: 'Data Sales',
                icon: 'user-chart',
                href: '/app/management/human-deliveries',
                hideOnSimpleDashboardView: true
            }
        ]
    },
    {
        subheader: 'Marketing',
        permissions: ['admin'],
        items: [
            {
                title: 'Messages',
                icon: 'comments-dollar',
                href: '/app/management/marketing-messages',
                hideOnSimpleDashboardView: true
            },
            {
                title: 'Templates',
                icon: 'mail-bulk',
                href: '/app/management/marketing-message-templates',
                hideOnSimpleDashboardView: true
            },
            {
                title: 'Import',
                icon: 'user-shield',
                href: '/app/management/import-humans',
                hideOnSimpleDashboardView: true
            }
        ]
    },
    {
        subheader: 'Management',
        permissions: ['admin'],
        items: [
            {
                title: 'Containers',
                icon: 'poll-people',
                href: '/app/management/containers'
            },
            {
                title: 'Campaigns',
                icon: 'user-chart',
                href: '/app/management/campaigns'
            },
            {
                title: 'Clients',
                icon: 'handshake',
                href: '/app/management/clients',
                hideOnSimpleDashboardView: true
            },
            {
                title: 'Deliveries',
                icon: 'truck-loading',
                href: '/app/management/deliveries',
                hideOnSimpleDashboardView: true
            },
            {
                title: 'Humans',
                icon: 'users',
                href: '/app/management/humans'
            },
            {
                title: 'Tracking',
                icon: 'chart-network',
                href: '/app/management/tracking-tags'
            }
        ]
    },
    /*
    {
        title: "Clients",
        icon: "handshake",
        href: "/app/management/customers"
    },
    {
        title: "Marketing Messages",
        icon: "mail-bulk",
        href: "/app/management/customers"
    },
    {
        title: "Users",
        icon: "users",
        href: "/app/management/customers"
    },*/
    {
        subheader: 'Tools',
        permissions: ['admin'],
        items: [
            {
                title: 'Find Visitor',
                icon: 'search',
                href: '/app/tools/visitors'
            },
            {
                title: 'File Systems',
                icon: 'file-spreadsheet',
                href: '/app/tools/filesystems'
            },
            {
                title: 'Export Humans',
                icon: 'file-export',
                href: '/app/tools/export'
            },
            {
                title: 'Reports',
                icon: 'chart-pie',
                href: '/app/tools/reports'
            },
            {
                title: 'Client Reports',
                icon: 'business-time',
                href: '/app/tools/client-reports'
            },
            {
                title: 'Export Requests',
                icon: 'bell',
                href: '/app/tools/export-requests'
            },
            {
                title: 'Quarantine Processor',
                icon: 'lock',
                href: '/app/tools/quarantine-processor'
            },
            {
                title: 'Register Analytics',
                icon: 'analytics',
                href: '/app/tools/register-analytics'
            },
            {
                title: 'Pick A Winner',
                icon: 'trophy',
                href: '/app/tools/pick-a-winner'
            },
            {
                title: 'White Label',
                icon: 'smile-plus',
                href: '/app/tools/white-label'
            },
            {
                title: 'System Status',
                icon: 'badge-check',
                href: '/app/system/status'
            }
        ]
    }
]

function renderNavItems({ items, ...rest }, user) {
    return <List disablePadding>{items.reduce((acc, item) => reduceChildRoutes({ acc, item, ...rest }, user), [])}</List>
}

function reduceChildRoutes({ acc, pathname, item, depth = 0 }, user) {
    const key = item.title + depth

    const isSimpleDashboardView = !!process.env.MIX_SIMPLE_DASHBOARD
    if (!hasPermission(item.permissions ?? null, user) || (item.hideOnSimpleDashboardView && isSimpleDashboardView)) {
        return acc
    }

    if (item.items) {
        const open = matchPath(pathname, {
            path: item.href,
            exact: false
        })

        acc.push(
            <NavItem depth={depth} icon={item.icon} key={key} info={item.info} open={Boolean(open)} title={item.title}>
                {renderNavItems({
                    depth: depth + 1,
                    pathname,
                    items: item.items
                })}
            </NavItem>
        )
    } else {
        acc.push(<NavItem depth={depth} href={item.href} icon={item.icon} key={key} info={item.info} title={item.title} />)
    }

    return acc
}

const useStyles = makeStyles(theme => ({
    mobileDrawer: {
        width: 256
    },
    desktopDrawer: {
        width: 256,
        top: 64,
        height: 'calc(100% - 64px)'
    },
    avatar: {
        cursor: 'pointer',
        width: 64,
        height: 64
    },
    avatarDefault: {
        backgroundColor: theme.palette.secondary.main
    },
    formControl: {
        width: '100%'
    },
    listItem: {
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1)
    },
    listIcon: {
        minWidth: theme.spacing(3)
    }
}))

function NavBar({ openMobile, onMobileClose }) {
    const classes = useStyles()
    const location = useLocation()
    const { user } = useSelector(state => state.account)
    const [loginAsUserId, setLoginAsUserId] = useState(-1)

    useEffect(() => {
        if (openMobile && onMobileClose) {
            onMobileClose()
        }
        // eslint-disable-next-line
    }, [location.pathname])

    const onLoginAsUser = event => {
        setLoginAsUserId(event.target.value)
        axios.get(`${process.env.MIX_API_URL}/auth/loginAs?userId=${event.target.value}`).then(res => {
            authService.setSession(res.data.access_token)
            window.location.reload()
        })
    }

    const isSimpleDashboardView = !!process.env.MIX_SIMPLE_DASHBOARD

    const content = (
        <Box height="100%" display="flex" flexDirection="column">
            <PerfectScrollbar options={{ suppressScrollX: true }}>
                <Hidden lgUp>
                    <Box p={2} display="flex" justifyContent="center">
                        <RouterLink to="/">
                            <Logo color="dark" maxwidth="150px" />
                        </RouterLink>
                    </Box>
                </Hidden>
                <Box p={2} pl={0}>
                    <Box display="flex" justifyContent="center">
                        <Avatar
                            alt="User"
                            className={classes.avatar}
                            src={user.profile_image_url}
                            classes={{ colorDefault: classes.avatarDefault }}
                        />
                    </Box>
                    <Box mt={2} textAlign="center">
                        <Typography variant="h5" color="textPrimary">
                            {`${user.name}`}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            {user.company_name}
                        </Typography>
                    </Box>
                </Box>
                <Divider />
                <Box p={2} pb={3}>
                    {navConfig.map(config => {
                        if (!hasPermission(config.permissions ?? null, user) || (config.hideOnSimpleDashboardView && isSimpleDashboardView)) {
                            return null
                        } else {
                            return (
                                <List
                                    key={config.subheader}
                                    subheader={
                                        <ListSubheader disableGutters disableSticky>
                                            {config.subheader}
                                        </ListSubheader>
                                    }
                                >
                                    {renderNavItems(
                                        {
                                            items: config.items,
                                            pathname: location.pathname
                                        },
                                        user
                                    )}
                                </List>
                            )
                        }
                    })}
                </Box>
                <Divider />
                <Box p={2}>
                    <Box p={2} borderRadius="borderRadius" bgcolor="background.dark">
                        <Typography variant="h6" color="textPrimary">
                            Tarvitsetko apua?
                        </Typography>
                        <Link variant="subtitle1" color="secondary" target="_blank" href="mailto:janne@leadspark.io">
                            janne@leadspark.io
                        </Link>
                    </Box>
                </Box>
                {user && user.permissions.includes('admin') && (
                    <>
                        <Divider />
                        <Box p={2} pl={1}>
                            <List>
                                <ListItem button key={'user-select'} component="div" className={classes.listItem}>
                                    <ListItemIcon className={classes.listIcon}>
                                        <FontAwesomeIcon icon={['far', 'user']} />
                                    </ListItemIcon>
                                    <FormControl className={classes.formControl}>
                                        <Select
                                            classes={{ root: classes.selectInput }}
                                            value={loginAsUserId}
                                            onChange={onLoginAsUser}
                                            inputProps={{
                                                name: 'age',
                                                id: 'age-simple'
                                            }}
                                        >
                                            <MenuItem value={-1} disabled={true}>
                                                <em>Login as User...</em>
                                            </MenuItem>
                                            {user.loginable_users &&
                                                user.loginable_users.map((user, key) => (
                                                    <MenuItem value={user.id} key={key}>
                                                        {user.username}
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                </ListItem>
                            </List>
                        </Box>
                    </>
                )}
            </PerfectScrollbar>
        </Box>
    )

    return (
        <>
            <Hidden lgUp>
                <Drawer anchor="left" classes={{ paper: classes.mobileDrawer }} onClose={onMobileClose} open={openMobile} variant="temporary">
                    {content}
                </Drawer>
            </Hidden>
            <Hidden mdDown>
                <Drawer anchor="left" classes={{ paper: classes.desktopDrawer }} open variant="persistent">
                    {content}
                </Drawer>
            </Hidden>
        </>
    )
}

NavBar.propTypes = {
    onMobileClose: PropTypes.func,
    openMobile: PropTypes.bool
}

export default NavBar
